/* checkbox-option-visual-refresh-sllv.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import "./checkbox-option-visual-refresh-sllv.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { CheckboxOption } from '@atlaskit/select';
var checkboxStyles = null;
var checkboxSelectedStyles = null;
var checkboxFocusedStyles = null;
export var CheckboxOptionVisualRefreshSllv = function CheckboxOptionVisualRefreshSllv(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CheckboxOption
  // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
  , _extends({}, props, {
    className: ax(["_189eyh40 _1dqonqa1 _1h6d1j28 _16qsglyw _bfhk1j9a _1q511b66 _85i51b66 _bozgpxbi _y4tipxbi _irr3166n _1di61dty", props.isSelected && "_bfhkfg4m _irr3i1yw _1di619ru", props.isFocused && "_1h6d1p6i"])
  }), children);
};